import moment from 'moment-timezone';
import { split } from 'lodash';

export function formatDateAsOrdinal(value: number, timeZone?: string): string {
  const date = moment.utc(value).tz(timeZone || 'UTC').format('YYYY-MM-DD');
  const day = split(date, '-', 3).pop();
  const localeData = moment.localeData();

  return localeData.ordinal(parseInt(day));
}

export function formatDateAsOrdinalWithMonth(value: number, timeZone?: string): string {
  return `${moment.utc(value).tz(timeZone || 'UTC').format('MMM')} ${formatDateAsOrdinal(value, timeZone)}`;
}

export function formatDateAsOrdinalWithFullMonthAndYear(value: number, timeZone?: string): string {
  return `${formatDateAsOrdinal(value, timeZone)} ${moment.utc(value).tz(timeZone || 'UTC').format('MMMM YYYY')}`;
}
